import { render, staticRenderFns } from "./user-info-card-group.vue?vue&type=template&id=1f8b9412&scoped=true&"
import script from "./user-info-card-group.vue?vue&type=script&lang=js&"
export * from "./user-info-card-group.vue?vue&type=script&lang=js&"
import style0 from "./user-info-card-group.vue?vue&type=style&index=0&id=1f8b9412&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b9412",
  null
  
)

export default component.exports